<template>
	<div class="fullwidth-block item">
		<div class="item-image">
			<nuxt-link :to="item.filename">
				<picture>
					<source :srcset="item.overviewImageWebp" type="image/webp" />
					<source :srcset="item.overviewImage" />
					<img loading="lazy" :src="item.overviewImage" :alt="item.overviewImageAlt" />
				</picture>
			</nuxt-link>
		</div>
		<div class="item-content">
			<h3>{{ item.title || item.header }}</h3>
			<p v-if="item.date">
				<strong>{{ $d(new Date(item.date.date.split(' ')[0]), 'short', locale) }}</strong>
			</p>
			<p>{{ item.overviewContent }}</p>
			<nuxt-link :to="item.filename" class="button">
				{{ $t('readMore') }}
			</nuxt-link>
		</div>
	</div>
</template>

<script setup>
const { locale } = useI18n();

defineProps({
	item: { type: Object, default: () => {} },
});
</script>

<style lang="scss" scoped>
.item {
	display: flex;
	padding: 40px;
	background: var(--primary-background-color);
	margin: 0 auto 40px;
	box-shadow: 0 0 5px rgb(0 0 0 / 10%);

	p,
	h3 {
		margin-bottom: 10px;
	}

	.item-image {
		padding-right: 20px;
		max-width: 30%;
	}

	.item-content {
		padding: 0 20px;
		max-width: 70%;
	}
}

@media (max-width: 580px) {
	.item {
		flex-direction: column;

		.item-image {
			margin-bottom: 20px;
		}

		.item-image,
		.item-content {
			max-width: 100%;
		}
	}
}
</style>
